import { render, staticRenderFns } from "./TituloProtocolo.vue?vue&type=template&id=197d8e18&"
import script from "./TituloProtocolo.vue?vue&type=script&lang=js&"
export * from "./TituloProtocolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports